// extracted by mini-css-extract-plugin
export default {"slider":"styles_slider__WOVDe","mobileGrid":"styles_mobileGrid__H2xol","desktopSlider":"styles_desktopSlider__DpWia","gridItem":"styles_gridItem__sKwHu"};